<template>
  <div class="ui-block">
    <div class="ui-block-title">
      <h6 class="title">Change your account personal information</h6>
    </div>
    <div class="ui-block-content card-header">
      <!-- Personal Information Form  -->
      <form>
        <div class="row">
          <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
            <SInput
              label="Username"
              type="text"
              ref="username"
              fieldClass="form-input"
              class="username"
              :required="true"
              v-model="personalInformation.username"
              :class="[
              {
                'has-value': personalInformation.username && !hasUsernameError,
                'has-error': hasUsernameError,
              },
            ]"
            @input="clearError"
            />
            <p
            v-if="usernameError !== true"
            id="error-container"
            class="text-danger text-center text-wrap"
          >
            {{ usernameError }}
          </p>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
            <SInput
              label="First name"
              type="text"
              v-model="personalInformation.firstName"
              ref="firstInput"
              :acceptOnlyLetters="true"
            />
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
            <SInput
              label="Last name"
              type="text"
              v-model="personalInformation.lastName"
              :acceptOnlyLetters="true"
            />
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-12 col-12 md-layout-item">
            <SInput
              label="Zip code"
              type="text"
              v-model="personalInformation.zip"
              @atBlur="checkZip"
              :isZipInput="true"
            />
            <p class="text-danger text-center" v-if="!personalInformation.zip">
              If the zipcode is empty, the information will not be saved
            </p>
            <p
              v-if="typeof zipTest !== 'boolean'"
              class="text-danger text-center"
            >
              {{ zipTest }}
            </p>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
            <SInput
              label="Country"
              type="text"
              v-model="personalInformation.country"
              :acceptOnlyLetters="true"
            />
          </div>
          <div class="profile-about-you description-box">
            <div class="form-group label-floating description-field">
              <div class="description-label">Write a little description about you</div>
              <textarea
                class="form-control input-description"
                v-model="personalInformation.description"
                maxlength="300"
              ></textarea>
            </div>
          </div>
          <div class="col col-lg-6 col-md-6 col-sm-12 col-12 update-btn">
            <button class="btn btn-blue btn-lg full-width" @click="saveChanges">
              UPDATE
            </button>
          </div>
        </div>
      </form>
    </div>
    <Modal
      id="modalPersonalInfo"
      title="Update personal information"
      buttonName="OK"
      @button="closeModal"
      ref="modal"
      @hidden="doTheAction()"
    >
      <div data-cy="modalChangePersonalInfoResult">{{ result }}</div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserHelperVue from "../../mixins/UserHelper.vue";
import SInput from "@/components/atoms/SInput.vue";
import Modal from "@/components/atoms/Modal.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import Global from "@/constants/Global.js";
import * as  axios from'axios';

export default {
  name: "FormPersonalInfo",
  props: ["user"],
  data() {
    return {
      currentPassword: "",
      hasUsernameError: false,
      usernameError:"",
      checkAvaliable: true,
      personalInformation: {
        username: "",
        firstName: "",
        lastName: "",
        description: "",
        zip: "",
        city: "",
        country: "",
      },
      result: null,
      modal: null,
      zipTest: "",
    };
  },
  components: { SInput, Modal },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    hasError() {
      return this.hasUsernameError;
    },
  },
  mixins: [UserHelperVue, ChatHelperVue],
  watch: {
    user: function (newUser) {
      if (newUser) {
        this.image = this.getUserImagePath(newUser);
        this.personalInformation = { ...this.user };
      }
    },
  },
  methods: {
    ...mapActions(["prepareUpdatedUser", "updateUser"]),
    async checkZip() {
      if (this.personalInformation.zip) {
        let isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(
          this.personalInformation.zip
        );
        if (!isValidZip) {
          this.zipTest =
            "Zipcode must have the one of the following pattern 00000 or 00000-0000";
        } else {
          this.zipTest = true;
        }
      }
      if (this.personalInformation.zip.length >= 5) {
        const url = 'https://app.zipcodebase.com/api/v1/search';
        const parametros = {
          apikey: '11ae8520-0f06-11ee-b81e-9ba872d04347',
          codes: this.personalInformation.zipCode,
          country: 'us'
        };

        const resposta = await axios.get(url, { params: parametros });
        this.personalInformation.city = resposta.data.results[`${this.credentials.zipCode}`][0].city;
      }
    },

    async checkUsernameAvailability() {
        const res = await fetch(Global.getServerDomain() + `/usernameAvailability`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: this.personalInformation.username,
            }),
          });
          return await res.json().then((response)=>{
            this.checkAvaliable = response.available
            return response;
          });
    },
    async saveChanges(e) {
      e.preventDefault();
      this.checkZip();
      this.checkUsername()
      this.checkErrs();
      await this.checkUsernameAvailability();
      if(!this.checkAvaliable){
        if(this.loggedUser.username !== this.personalInformation.username){
          this.usernameError = "Username already taken, please provide another username";
          this.hasUsernameError = true;
        }
      }
      if(!this.hasUsernameError){
        await this.prepareUpdatedUser({ ...this.personalInformation });
        await this.updateUser();
      }
      if (this.zipTest === true && this.personalInformation.username && !this.hasUsernameError) {
        await this.fetchSystemNotifications();
        this.result = "Information updated!";
        $("#modalPersonalInfo").modal("show");
      }
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },

    doTheAction() {
      window.location.reload();
    },

    checkUsername() {
      if (!this.personalInformation.username) {
        this.usernameError = "This field cannot be empty";
        this.hasUsernameError = true;
        return;
      }
      this.usernameError = null;
      this.hasUsernameError = false;
    },

    checkErrs() {
      if (this.hasError) {
        this.$emit("hasError");
      } else {
        this.$emit("noError");
      }
    },

    clearError() {
      this.hasUsernameError = false;
      this.usernameError = null;
    },

    getUserNameError(){
      return this.usernameError;
    }
  },
  mounted() {
    if (this.user.username) {
      this.personalInformation.username = this.user.username;
    }
    if (this.user.firstName) {
      this.personalInformation.firstName = this.user.firstName;
    }
    if (this.user.lastName) {
      this.personalInformation.lastName = this.user.lastName;
    }
    if (this.user.description) {
      this.personalInformation.description = this.user.description;
    }
    if (this.user.zip) {
      this.personalInformation.zip = this.user.zip;
    }
    if (this.user.country) {
      this.personalInformation.country = this.user.country;
    }
    if (this.user.city) {
      this.personalInformation.city = this.user.city;
    }

  },
};
</script>
<style scoped>
.field-body,
.card-header {
  border: unset;
}

.profile-image,
.profile-image-button {
  flex: unset !important;
  max-width: unset;
  width: unset;
}

.remove-btn {
  border: none;
  background-color: unset;
  font-weight: 700;
  color: red;
}

.image-responsive {
  max-width: unset;
  width: 100px;
  height: 100px;
  border-radius: 100%;
}

.profile-about-you {
  margin-bottom: 15px;
  flex: 100%;
  max-width: 100%;
}
.description-box {
  display: flex;
  flex-direction: column;
  margin: 0 15px;
}
.input-description {
  border: none;
  padding: 0 1.1rem 0.2rem !important;
}
.description-field {
  border: 1px solid #979797;
}
.description-label {
  padding: 11px 17px;
  font-size: 11px;
  line-height: 1.07143;
}
</style>

<style lang="scss">
.has-value .md-field.md-theme-swampum-primary label {
  color: $primary !important;
}
.has-value .form-input {
  border: 1px solid $primary;
}
.has-error:first-child  .md-field.md-theme-swampum-primary label {
  border: $danger !important;
}
.has-error .form-control {
  border: 1px solid $danger !important;
}
.text-danger {
  margin-top: -1rem
}
.username-input.has-error .form-input {
  margin-bottom: 0;
}
.email-input.has-error .form-input {
  margin-bottom: 1rem;
}
.checkbox-terms {
  color: $tertiary !important;
}
::-webkit-scrollbar {
  width: 10px !important;
}
::-webkit-scrollbar-thumb {
  cursor: auto !important;
}
</style>

